/**
 * Opt-in marker clustering for leads map (desktop + mobile).
 *
 * Desktop enable:
 * - REACT_APP_LEADS_MAP_CLUSTER=true
 * - URL ?mapCluster=1 or ?mapCluster=true
 * - localStorage leadsMapCluster = "1" or "true"
 *
 * Mobile enable (separate flag):
 * - REACT_APP_LEADS_MAP_CLUSTER_MOBILE=true
 * - URL ?mapClusterMobile=1 or ?mapClusterMobile=true
 * - localStorage leadsMapClusterMobile = "1" or "true"
 */

/** Desktop: individual pins at street zoom and above. */
export const LEADS_MAP_CLUSTER_DESKTOP_OPTS = {
  disableClusteringAtZoom: 15,
  maxClusterRadius: 50,
};

/** Phone: cluster at zoom ≤12; individual pins at zoom ≥13. */
export const LEADS_MAP_CLUSTER_MOBILE_PHONE_OPTS = {
  disableClusteringAtZoom: 13,
  maxClusterRadius: 45,
};

/** Tablet (mobile layout): same decluster threshold as phone. */
export const LEADS_MAP_CLUSTER_MOBILE_TABLET_OPTS = {
  disableClusteringAtZoom: 13,
  maxClusterRadius: 50,
};

function isClusterFlagEnabled(envTrue, urlKeys, storageKey, searchParams) {
  if (process.env[envTrue] === "true") {
    return true;
  }
  try {
    for (const key of urlKeys) {
      const q = searchParams?.get?.(key);
      if (q === "1" || q === "true") return true;
    }
  } catch {
    /* ignore */
  }
  try {
    const v = localStorage.getItem(storageKey);
    if (v === "1" || v === "true") return true;
  } catch {
    /* ignore */
  }
  return false;
}

export function isLeadsMapClusteringEnabled(searchParams) {
  return isClusterFlagEnabled(
    "REACT_APP_LEADS_MAP_CLUSTER",
    ["mapCluster"],
    "leadsMapCluster",
    searchParams
  );
}

export function isLeadsMapMobileClusteringEnabled(searchParams) {
  return isClusterFlagEnabled(
    "REACT_APP_LEADS_MAP_CLUSTER_MOBILE",
    ["mapClusterMobile"],
    "leadsMapClusterMobile",
    searchParams
  );
}

export function getLeadsMapMobileClusterOptions(isPhoneViewport) {
  return isPhoneViewport
    ? LEADS_MAP_CLUSTER_MOBILE_PHONE_OPTS
    : LEADS_MAP_CLUSTER_MOBILE_TABLET_OPTS;
}

/** Crosshair visible when map zoom >= this (desktop). */
export const USER_LOCATION_MIN_ZOOM = 12;

/** Mobile: show crosshair one zoom level sooner than desktop. */
export const USER_LOCATION_MIN_ZOOM_MOBILE = 11;

export const USER_LOCATION_MIN_ZOOM_DESKTOP = USER_LOCATION_MIN_ZOOM;

/** Target zoom when user taps "My Location". */
export const USER_LOCATION_LOCATE_ZOOM = 16;

/** Desktop: subtle pulse on crosshair at these zoom levels (cluster overlap range). */
export const USER_LOCATION_PULSE_ZOOM_MIN = 12;
export const USER_LOCATION_PULSE_ZOOM_MAX = 15;

export function getUserLocationMinZoom(_isPhoneViewport) {
  return USER_LOCATION_MIN_ZOOM_MOBILE;
}

export const USER_LOCATION_ACCURACY_PATH_OPTIONS = {
  color: "#136AEC",
  fillColor: "#136AEC",
  fillOpacity: 0.15,
  weight: 0,
  opacity: 0,
};
